import React from 'react';
import { Marker, Popup } from 'react-leaflet';
import type { LeafletEventHandlerFnMap } from 'leaflet';
import type { PlacedSymbol } from '@/config/sitac';
import type { SITACSymbolWithCategory } from '../../components/SITAC/SITACSymbolSelector';

interface SITACSymbolsLayerProps {
  placedSymbols: PlacedSymbol[];
  createSITACIcon: (
    symbol: SITACSymbolWithCategory,
    rotation?: number,
    scale?: number
  ) => L.DivIcon | L.Icon;
  setSelectedSymbolId: (id: string | null) => void;
  onMoveSymbol?: (symbolId: string, lat: number, lng: number) => void;
  readOnly?: boolean;
  dragEnabled?: boolean;
}

const SITACSymbolsLayer: React.FC<SITACSymbolsLayerProps> = ({
  placedSymbols,
  createSITACIcon,
  setSelectedSymbolId,
  onMoveSymbol,
  readOnly = false,
  dragEnabled = true,
}) => {
  return (
    <>
      {placedSymbols.map((symbol) => {
        const eventHandlers: LeafletEventHandlerFnMap = {
          click: () => {
            setSelectedSymbolId(symbol.id);
          },
          dragstart: () => {
            setSelectedSymbolId(symbol.id);
          },
          dragend: (e) => {
            const marker = e.target;
            const latlng = marker.getLatLng();
            onMoveSymbol?.(symbol.id, latlng.lat, latlng.lng);
            setSelectedSymbolId(symbol.id);
          },
        };

        return (
          <Marker
            key={symbol.id}
            position={[symbol.position.lat, symbol.position.lng]}
            icon={createSITACIcon(
              symbol.symbol,
              symbol.rotation || 0,
              symbol.scale || 1
            )}
            draggable={!readOnly && dragEnabled}
            eventHandlers={eventHandlers}
          >
            <Popup>
              <div>
                <strong>{symbol.symbol.descrizione}</strong>
                <br />
                Lat: {symbol.position.lat.toFixed(6)}
                <br />
                Lng: {symbol.position.lng.toFixed(6)}
              </div>
            </Popup>
          </Marker>
        );
      })}
    </>
  );
};

export default SITACSymbolsLayer;